import type {
  CreateSnapQuoteAttachmentOutput,
  CreateSnapQuoteAttachmentRequest,
} from '@snap-types/actions/create-snap-quote-attachment';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [createSnapQuoteAttachment, useCreateSnapQuoteAttachmentMutation] =
  injectMutation<
    CreateSnapQuoteAttachmentRequest,
    CreateSnapQuoteAttachmentOutput
  >(
    `${QUOTE_BUILDER_SLICE_NAME}/createSnapQuoteAttachment`,
    ({ params, body }) => ({
      url: buildSnapQuoteUrl(
        params.siteCode,
        params.snapQuoteUuid,
        `${params.snapQuoteVersionUuid}/attachments`,
      ),
      method: 'POST',
      body,
    }),
  );
